import { useAppSelector } from 'hooks/redux.hooks';
import { getUserDetails } from 'state/reducers/user.reducers';

interface IProps {
	children: any;
	permissions: string[];
}

export const hasPermission = (permissionsRequired: string[]) => {
	const { permissions } = useAppSelector(getUserDetails);
	return permissions?.permissions && permissions?.permissions?.includes(...permissionsRequired);
};

export const AuthorizationComponent = ({ children, permissions }: IProps) => {
	return <>{hasPermission(permissions) ? children : null}</>;
};
